import SEO from '@/components/feature/SEO';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import PopularMovies from './components/PopularMovies';
import LatestMovies from './components/LatestMovies';
import AllMoviesSection from './components/AllMoviesSection';

export default function Home() {
  return (
    <>
      <SEO
        title="97影视 - 97影视网电影大全，最新高清电影免费在线看"
        description="97影视汇聚海量电影资源，涵盖动作片、喜剧片等各类最新高清电影，全集免费在线观看，播放流畅不缓冲，给您极致观影体验。97影视电影大全，最新电影在线看。"
        keywords="97影视,电影大全,最新电影,高清电影,动作片,喜剧片,免费电影,在线看片,极速播放"
        canonical="https://www.97yingshi.com/"
        ogTitle="97影视 - 97影视网电影大全，最新高清电影免费在线看"
        ogDescription="97影视汇聚海量电影资源，涵盖动作片、喜剧片等各类最新高清电影，全集免费在线观看，播放流畅不缓冲。"
        ogUrl="https://www.97yingshi.com/"
        ogType="website"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '97影视首页',
          description: '97影视网电影大全，最新高清电影免费在线看',
          url: 'https://www.97yingshi.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '97影视',
            url: 'https://www.97yingshi.com',
          },
        }}
      />

      <main>
        <HeroBanner />
        <CategoryNav />
        <PopularMovies />
        <LatestMovies />
        <AllMoviesSection />
      </main>
    </>
  );
}